export default function SetupFormComponent(props, {emit}) {
    const updateValue = (event) => {
        let val = event.target.value

        if (event.target.type === 'checkbox') {
            let modelValue = [...props.modelValue]

            val = props.value

            if (event.target.checked) {
                modelValue.push(val)
            } else {
                modelValue.splice(modelValue.indexOf(val), 1)
            }

            val = modelValue
        } else if (event.target.type === 'radio') {
            val = props.value
        }

        emit('update:modelValue', val)
    }

    return {updateValue}
}
